import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "user-container" }
const _hoisted_2 = { class: "admin-top" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("i", { class: "fal fa-angle-left" }, null, -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("div", { style: {"margin-left":"auto"} }, null, -1)
const _hoisted_5 = { style: {"display":"flex","align-items":"center","gap":"15px"} }
const _hoisted_6 = { class: "admin-stage" }
const _hoisted_7 = {
  class: "preferences-top",
  style: {"max-width":"1200px"}
}
const _hoisted_8 = { class: "preferences-details" }
const _hoisted_9 = { class: "preferences-item" }
const _hoisted_10 = { class: "preferences-value" }
const _hoisted_11 = { class: "preferences-item" }
const _hoisted_12 = { class: "preferences-value" }
const _hoisted_13 = { class: "preferences-item" }
const _hoisted_14 = { class: "preferences-value" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_imdex_btn = _resolveComponent("imdex-btn")!
  const _component_imdex_select = _resolveComponent("imdex-select")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_imdex_btn, {
        style: {"margin-right":"15px","font-size":"25pt"},
        onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$router.go(-1))),
        text: "",
        compact: "",
        secondary: ""
      }, {
        default: _withCtx(() => [
          _hoisted_3
        ]),
        _: 1
      }),
      _createElementVNode("span", null, _toDisplayString(_ctx.$t("userPreferences.title")), 1),
      _hoisted_4,
      _createElementVNode("div", _hoisted_5, [
        _createVNode(_component_imdex_btn, {
          onClick: _ctx.submitSavePreferences,
          secondary: "",
          loading: _ctx.isLoading
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.$t("userPreferences.save")), 1)
          ]),
          _: 1
        }, 8, ["onClick", "loading"])
      ])
    ]),
    _createElementVNode("div", _hoisted_6, [
      _createElementVNode("div", _hoisted_7, [
        _createElementVNode("div", _hoisted_8, [
          _createElementVNode("div", _hoisted_9, [
            _createElementVNode("span", null, _toDisplayString(_ctx.$t("userPreferences.defaultMineSite")), 1),
            _createElementVNode("div", _hoisted_10, [
              _createVNode(_component_imdex_select, {
                class: "minesite-select",
                items: _ctx.availableSites,
                value: _ctx.defaultMineSite,
                "onUpdate:value": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.defaultMineSite) = $event))
              }, null, 8, ["items", "value"])
            ])
          ]),
          _createElementVNode("div", _hoisted_11, [
            _createElementVNode("span", null, _toDisplayString(_ctx.$t("userPreferences.timeZoneLabel")), 1),
            _createElementVNode("div", _hoisted_12, [
              _createVNode(_component_imdex_select, {
                class: "timezone-select",
                searchable: "",
                items: _ctx.availableTimezones,
                value: _ctx.timezone,
                "onUpdate:value": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.timezone) = $event))
              }, null, 8, ["items", "value"])
            ])
          ]),
          _createElementVNode("div", _hoisted_13, [
            _createElementVNode("span", null, _toDisplayString(_ctx.$t("userPreferences.languageLabel")), 1),
            _createElementVNode("div", _hoisted_14, [
              _createVNode(_component_imdex_select, {
                class: "language-select",
                items: _ctx.languageOptions,
                value: _ctx.language,
                "onUpdate:value": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.language) = $event))
              }, null, 8, ["items", "value"])
            ])
          ])
        ])
      ])
    ])
  ]))
}